import { Grid } from "@mui/material";
import MaintenanceTabs from "./Tabs";
import CardsInformativos from "./CardsInformativos";

export default function HomePage() {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CardsInformativos />
      </Grid>

      <Grid item xs={12} style={{ textAlign: "center" }}>
        <MaintenanceTabs />
      </Grid>
    </Grid>
  );
}
